import { useMemo } from "react"
import { useDate } from "src/shared/hooks/useDate"
import { useCountdown } from "src/shared/hooks/useCountdown"
import { APARTADA_DURATION_MS } from "../constants/apartada"

// Sin dateStatusChanged la cuenta queda fija en el tiempo completo
export const useApartadaCountdown = (dateStatusChanged?: string) => {
    const { UTCStringToLocalDate } = useDate()
    const startDate = useMemo(
        () => (dateStatusChanged ? UTCStringToLocalDate(dateStatusChanged) : undefined),
        [dateStatusChanged]
    )

    return useCountdown(startDate, APARTADA_DURATION_MS)
}
